import React, { useEffect, useState } from "react"
import { Tabs, Card, Button, message } from "antd"
import { AppstoreOutlined, SettingOutlined, DatabaseOutlined, DollarOutlined, ArrowLeftOutlined, FilePdfOutlined } from "@ant-design/icons"
import { DeviceManagement, EstimationTab, UnitManagement } from "../../Components"
import { fetchStats, verifyToken } from "../../utils/helpers"
import { useHistory, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { resetStats } from "../../Redux/actions/statsActions"
import { translations } from "../../utils/constants"
import axios from "axios"
import { GET } from "../../utils/apis"
import { Euro } from "lucide-react"

const VehicleDetails = ({ language }) => {
    const history = useHistory()
    const location = useLocation()
    const dispatch = useDispatch()
    const user = useSelector((state) => state.authReducer?.user)
    const { units, systems, totalCost } = useSelector((state) => state.stats)
    const vehicle = location.state?.vehicle
    const vehicleId = vehicle?.id
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        verifyToken(history, dispatch)
    }, [history, dispatch])

    useEffect(() => {
        if (user?.id && vehicle?.id) fetchStats({ dispatch, user, vehicleId })
    }, [user, vehicle])

    const handleExportEstimation = async () => {
        try {
            setLoading(true)
            const response = await axios.get(
                `${GET?.GET_ESTIMATION_PDF}?user_id=${user.id}&vehicle_id=${vehicleId}&role=${user.role}&language=${language}`,
                { responseType: "blob" }
            )

            const contentType = response.headers["content-type"]

            if (contentType !== "application/pdf") {
                const reader = new FileReader()
                reader.onload = () => {
                    message.error("Server returned non-PDF response: " + reader.result, 5)
                }
                reader.readAsText(response.data)
                return
            }

            const blob = new Blob([response.data], { type: "application/pdf" })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", `Estimation_${vehicleId}.pdf`)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)

            message.success(translations[language]?.vehicleReportDownload, 3)
        } catch (error) {
            console.error("PDF Export Error:", error)
            message.error(translations[language]?.vehicleReportDownloadFailed, 5)
        } finally {
            setLoading(false)
        }
    }

    const isUser = user?.role === "user"

    return (
        <div className="container">
            <div style={{ width: "102px" }}>
                <Button
                    type="primary"
                    icon={<ArrowLeftOutlined />}
                    onClick={() => {
                        dispatch(resetStats())
                        history.goBack()
                    }}
                    className="export-btn"
                >
                    {translations[language]?.GoBack}
                </Button>
            </div>
            <div
                style={{
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <div>
                    <div>
                        <h1 className="timesheet-title">
                            {translations[language]?.EstimationDashboard}
                        </h1>
                        <p className="timesheet-subtitle">
                            {translations[language]?.DashboardSubtitle}
                        </p>
                    </div>
                </div>

                <div className="export-btn-div">
                    <Button
                        className="export-btn"
                        type="primary"
                        icon={<FilePdfOutlined />}
                        loading={loading}
                        onClick={handleExportEstimation}
                    >
                        {translations[language].exportPdf}
                    </Button>
                </div>
            </div>
            {!isUser && (
                <div className="stats-row">
                    <Card className="stat-card" bordered={false} loading={loading}>
                        <div className="stat-value">{units}</div>
                        <div className="stat-label">{translations[language]?.Units}</div>
                        <DatabaseOutlined className="stat-icon blue" />
                    </Card>
                    <Card className="stat-card" bordered={false} loading={loading}>
                        <div className="stat-value">{systems}</div>
                        <div className="stat-label">{translations[language]?.Devices}</div>
                        <AppstoreOutlined className="stat-icon green" />
                    </Card>
                    <Card className="stat-card" bordered={false} loading={loading}>
                        <div className="stat-value">€{totalCost.toFixed(2)}</div>
                        <div className="stat-label">{translations[language]?.TotalCost}</div>
                        <Euro className="stat-icon purple" />
                    </Card>
                </div>
            )}
            {isUser ?
                <EstimationTab language={language} vehicleId={vehicle?.id} />
                :
                <Tabs
                    defaultActiveKey="1"
                    type="card"
                    className="custom-tabs"
                    scroll={{ x: 'max-content' }}
                    // className="custom-timesheet-table"
                    items={[
                        {
                            key: "1",
                            label: (
                                <span>
                                    <DatabaseOutlined /> {translations[language]?.CostEstimation}
                                </span>
                            ),
                            children: (
                                <EstimationTab language={language} vehicleId={vehicle?.id} />
                            ),
                        },
                        {
                            key: "2",
                            label: (
                                <span>
                                    <SettingOutlined /> {translations[language]?.UnitsManagement}
                                </span>
                            ),
                            children: (
                                <UnitManagement language={language} vehicleId={vehicle?.id} />
                            ),
                        },
                        {
                            key: "3",
                            label: (
                                <span>
                                    <AppstoreOutlined /> {translations[language]?.DevicesManagement}
                                </span>
                            ),
                            children: (
                                <DeviceManagement language={language} vehicleId={vehicle?.id} />
                            ),
                        },
                    ]}
                />
            }
        </div>


    )
}

export default VehicleDetails
